import i18n from '../i18n'
const { t } = i18n.global

export enum CLIENT_TABS {
  CONTACT_PEOPLE = 'contactPeople',
  BOOKINGS = 'bookings',
  BILLING = 'billing',
  FEEDBACK = 'feedback',
}

export const getClientTabTranslation = (key: string) => {
  return {
    [CLIENT_TABS.CONTACT_PEOPLE]: t('clientTab.contactPeople'),
    [CLIENT_TABS.BOOKINGS]: t('clientTab.bookings'),
    [CLIENT_TABS.BILLING]: t('clientTab.billing'),
    [CLIENT_TABS.FEEDBACK]: t('clientTab.feedback'),
  }[key]
}

export enum GENDER {
  MALE = 'male',
  FEMALE = 'female',
  OTHER = 'other',
}

export enum CLIENT_FILTERS {
  SEARCH = 'SEARCH',
  IS_BUSINESS_CLIENT = 'IS_BUSINESS_CLIENT',
}

export enum TRAVEL_PURPOSE {
  VACATION = 'VACATION',
  WORK = 'WORK',
  OTHER = 'OTHER',
}

export enum AGE_GROUP {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
}

export enum CHECK_IN_STATUS {
  SUBMITTED = 'SUBMITTED',
  UNSUBMITTED = 'UNSUBMITTED',
}

export enum CHECK_IN_VARIABLE {
  FIRST_NAME = '[FIRST_NAME]',
  LAST_NAME = '[LAST_NAME]',
  FULL_NAME = '[FULL_NAME]',
  START = '[START]',
  END = '[END]',
  FULL_PRICE = '[FULL_PRICE]',
  DURATION = '[DURATION]',
  SERVICE_NAME = '[SERVICE_NAME]',
  SERVICE_ADDRESS = '[SERVICE_ADDRESS]',
  CHECK_IN_URL = '[CHECK_IN_URL]',
  DOOR_CODE = '[DOOR_CODE]',
  UNIT_NAME = '[UNIT_NAME]',
}
